import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { ProductSelectionPartsModel } from "@tCooneyBrothers/ApiModels";

const productSelectionPartsUrl = "api/v2/productselectionparts";

export async function getProductSelectionParts(productId: string) {
    try {
        const cpnCollection = await get<ProductSelectionPartsModel[]>(`${productSelectionPartsUrl}/${productId}`, {})
            .then(response => {
                // eslint-disable-next-line no-console
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return cpnCollection;
        // eslint-disable-next-line no-empty
    } catch (error) {}
}
